import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { technicianLeaveList } from "constants/technicianLeave";

//get or list technician leave
export const getTechnicianLeave = async (technicianId ,dispatch) => {
  try {
    const res = await api.get_technician_leave(technicianId);
    dispatch({type : technicianLeaveList , payload : res.data});
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//get techncian leave by technician id
export const getTechnicianLeaveByTechnicianID = async (id, technicianID) => {
  try {
    const res = await api.get_technician_leave_by_ID(id, technicianID);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//add techncian leave
export const addTechnicianLeave = async (bodyData) => {
  try {
    const res = await api.add_technician_leave(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//update technician leave by technician id
export const editTechnicianLeave = async (id, technicianID, bodyData) => {
  try {
    const res = await api.edit_technician_leave(id, technicianID, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
